import { useState } from "react";
import "./App.css";
import MyContext from "./InvoiceForm/Context";
import Navbar from "./InvoiceForm/Navbar";
import Invoice from "./InvoiceForm/Invoice";
import Preview from "./InvoiceForm/Preview";

function App() {
  // Company Details
  const [companyName, setCompanyName] = useState("");
  const [name, setName] = useState("");
  const [gstin, setGstin] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");

  // Invoice Details
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");

  // Client Details
  const [clientCompany, setClientCompany] = useState("");
  const [clientGstin, setClientGstin] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientAddress2, setClientAddress2] = useState("");
  const [clientCity, setClientCity] = useState("");
  const [clientState, setClientState] = useState("");
  const [clientCountry, setClientCountry] = useState("");

  // Ship Details
  const [shipToCompany, setShipToCompany] = useState("");
  const [shipToGstin, setShipToGstin] = useState("");
  const [shipToAddress, setShipToAddress] = useState("");
  const [shipToAddress2, setShipToAddress2] = useState("");
  const [shipToCity, setShipToCity] = useState("");
  const [shipToState, setShipToState] = useState("");
  const [shipToCountry, setShipToCountry] = useState("");

  // table Details
  const [tableData, setTableData] = useState([]);

  const [imageUrl, setImageUrl] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [gst, setGst] = useState(0);
  const [total, setTotal] = useState(0);

  const [notes, setNotes] = useState("");
  const [terms, setTerms] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  const [selectedContainer, setSelectedContainer] = useState(null);
  const [forceRerender, setForceRerender] = useState(0); // Used to force re-render

  const [toggleSwitch, setToggleSwitch] = useState(false);

  // Function to close popup

  const data = {
    companyName,
    setCompanyName,
    name,
    setName,
    gstin,
    setGstin,
    address,
    setAddress,
    address2,
    setAddress2,
    city,
    setCity,
    state,
    setState,
    country,
    setCountry,
    invoiceNumber,
    setInvoiceNumber,
    invoiceDate,
    setInvoiceDate,
    dueDate,
    setDueDate,
    clientCompany,
    setClientCompany,
    clientGstin,
    setClientGstin,
    clientAddress,
    setClientAddress,
    clientAddress2,
    setClientAddress2,
    clientCity,
    setClientCity,
    clientState,
    setClientState,
    clientCountry,
    setClientCountry,
    shipToCompany,
    setShipToCompany,
    shipToGstin,
    setShipToGstin,
    shipToAddress,
    setShipToAddress,
    shipToAddress2,
    setShipToAddress2,
    shipToCity,
    setShipToCity,
    shipToState,
    setShipToState,
    shipToCountry,
    setShipToCountry,
    tableData,
    setTableData,
    imageUrl,
    setImageUrl,
    subTotal,
    setSubTotal,
    cgst,
    setCgst,
    sgst,
    setSgst,
    gst,
    setGst,
    total,
    setTotal,
    notes,
    setNotes,
    terms,
    setTerms,
    showPreview,
    setShowPreview,
    // closePopup,
    selectedContainer,
    forceRerender,
    setSelectedContainer,
    setForceRerender,
    toggleSwitch,
    setToggleSwitch,
  };

  return (
    <div className="App">
      <MyContext.Provider value={data}>
        <Navbar />
        <section style={{ display: "flex", justifyContent: "space-evenly" }}>
          <div className="content">
            <div className="preview-container">
              <Preview />
            </div>
          </div>
          <Invoice />
        </section>
      </MyContext.Provider>
    </div>
  );
}

export default App;
